<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="form-group col-md-3">
                        <label>Zone</label>
                        <ng-select [items]="filterZoneList" bindLabel="zone_name" bindValue="id"
                            placeholder="Select Zones" [multiple]="true" appendTo="body"
                            (change)="onFilterZoneChange($event)"
                            [(ngModel)]="filterZoneIds">
                        </ng-select>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Ward</label>
                        <ng-select [items]="filterWardList" bindLabel="ward_name" bindValue="id"
                            placeholder="Select Wards" [multiple]="true" appendTo="body"
                            (change)="onFilterWardChange($event)"
                            [(ngModel)]="filterWardIds">
                        </ng-select>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Search</label>
                        <input type="text" class="form-control form-control-sm" placeholder="Search Toilet, Address, ID..."
                            (input)="applyFilter()" [(ngModel)]="searchText">
                    </div>
                    <!-- <div class="form-group col-md-2" style="margin-top: 15px;">
                        <button class="btn btn-outline-danger btn-sm w-100" (click)="resetFilter()">Reset Filter</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <div class="row">
            <div class="col-md-3 mb-1" *ngFor="let item of rowData">
                
                <div class="card device-card"
                    [ngClass]="{
                        'active-box': item.status === 'Active' && item.person_count > 0,
                        'warning-box': item.status === 'Active' && item.person_count == 0,
                        'inactive-box': item.status !== 'Active'
                    }">

                    <div class="card-body p-0">
                        <!-- Row 1: Zone / Ward + Time -->
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <div class="zone-ward-text">
                                {{item.zone_name}} / {{item.ward_name}}
                            </div>
                            <div class="log-time">
                                {{item.log_date_time}}
                            </div>
                        </div>

                        <!-- Row 1.5: Address -->
                        <div class="address-text mb-1" style="font-size: 11px; color: #444;">
                            {{item.address}}
                        </div>

                        <!-- Row 2: Toilet No + AQI + Person Count (ALL IN SAME LINE) -->
                        <div class="d-flex justify-content-between align-items-center">

                            <div class="toilet-no">
                                {{item.toilet_no}}
                            </div>

                            <div class="d-flex align-items-center">

                                <!-- AQI -->
                                <div class="aqi-box me-2">
                                    AQI: <strong>({{item.air_quality_status}})</strong>
                                </div>

                                <!-- Person Count -->
                                <div class="person-bracket">
                                    <strong>({{item.person_count}})</strong>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
